import styled from 'styled-components';

export const Container = styled.div`
    min-width: 320px;
    background: var(--background);
    color: var(--text-primary);
`;